// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__7FtaH","alertIcon":"ConfirmModal_alertIcon__36DYu"};